module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki17_sp-b57d212c31aaf563d2a8d9950325c334.jpg";